module.exports = __webpack_public_path__ + "43a7284868a47aa1ac0d0d5995c70fb1.svg";